import { apiClient, getEndpoints } from '../common';
import { WORKSPACE_NAMESPACE } from '../hooks';

export function joinWorkspace(workspaceId: string) {
	const baseUrl = getEndpoints(WORKSPACE_NAMESPACE).byId(workspaceId);
	const url = `${baseUrl}join/`;
	return apiClient.post(url, {});
}
